import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { addFile } from "../addFile";
import { createVariation } from "../projectVariations";
import { queryKeys } from "../queryKeys";
import { portalApiClient } from "../apiClient";
import { apiUrls } from "src/consts/ApiUrls";

export default function useDeleteVariation() {
  const { companyId } = useParams();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async function ({
      variationId,
    }: {
      variationId: number | string;
    }) {
      const result = await portalApiClient.delete(
        apiUrls.deleteVariationById.url(variationId)
      );
      return result;
    },
    mutationKey: [queryKeys.variations(companyId), "Delete"],
    throwOnError: true,
    onSuccess: async () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.variations(companyId!),
      }),
  });

  return mutation;
}
